var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 -13.333)"},[React.createElement("path",{"d":"M1.667,15H78.333V65H1.667Z","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3.333","key":0}),React.createElement("path",{"d":"M68.333,28.333,40,46.667,11.667,28.333","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3.333","key":1}),React.createElement("path",{"d":"M11.667,53.333l11.667-6.667","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3.333","key":2}),React.createElement("path",{"d":"M68.333,53.333,56.667,46.667","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3.333","key":3})]));
}

Mail.defaultProps = {"width":"80","height":"53.333","viewBox":"0 0 80 53.333"};

module.exports = Mail;

Mail.default = Mail;
